import React from 'react';
import * as BillingDetailsListeners from '@atlassian/commerce-billing-details/telemetry-listeners';
import * as BillingHistoryListeners from '@atlassian/commerce-billing-history/telemetry-listeners';
import * as CreditCardCcpListeners from '@atlassian/commerce-credit-card-ccp/telemetry-listeners';
import * as CreditCardHamsListeners from '@atlassian/commerce-credit-card-hams/telemetry-listeners';
import * as CommerceEnviromentListeners from '@atlassian/commerce-environment/telemetry-listeners';
import * as PaymentFlowListeners from '@atlassian/commerce-payment-flow/telemetry-listeners';
import { ChannelVersionFragmentationSafeGuard } from '@atlassian/commerce-telemetry';
import * as UIListeners from '@atlassian/commerce-telemetry/listeners';
var SafeGuard = function SafeGuard(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(ChannelVersionFragmentationSafeGuard, {
    childPackageListenerModules: [BillingDetailsListeners, BillingHistoryListeners, CommerceEnviromentListeners, CreditCardCcpListeners, CreditCardHamsListeners, PaymentFlowListeners]
  }, children);
};
export var withSafeGuard = function withSafeGuard(Component) {
  return function (props) {
    return /*#__PURE__*/React.createElement(Component, props, SafeGuard({
      children: props.children
    }));
  };
};
export var GasV3UIEventListener = withSafeGuard(UIListeners.GasV3UIEventListener);
export var GasV3ScreenEventListener = withSafeGuard(UIListeners.GasV3ScreenEventListener);
export var GasV3TrackEventListener = withSafeGuard(UIListeners.GasV3TrackEventListener);
export var GasV3OperationalEventListener = withSafeGuard(UIListeners.GasV3OperationalEventListener);
export var MetalListener = withSafeGuard(UIListeners.MetalListener);
export var SentryExceptionListener = withSafeGuard(UIListeners.SentryExceptionListener);